import { getProfileDetails } from './Apis/me'

export const hasPermissionForAdmin = async () => {
  const getUser = await getProfileDetails()
  if (getUser?.user?.role === 'admin') {
    return true
  }
  return false
}
